import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import deleteKeyIcon from "assets/icons/delete-key-icon.svg";
import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";
import NumCol from "./NumCol";

interface IProps {
  onTap: (str: string) => void;
  hasDecimal?: boolean;
  hasEnter?: boolean;
}

const NumPad = ({ onTap, hasDecimal, hasEnter }: IProps) => {
  const onClickHandler = (str: string) => () => {
    onTap(str);
  };
  return (
    <NumPadContainer>
      <NumCol handleAction={onClickHandler("1")}>1</NumCol>
      <NumCol handleAction={onClickHandler("2")}>2</NumCol>
      <NumCol handleAction={onClickHandler("3")}>3</NumCol>
      <NumCol handleAction={onClickHandler("4")}>4</NumCol>
      <NumCol handleAction={onClickHandler("5")}>5</NumCol>
      <NumCol handleAction={onClickHandler("6")}>6</NumCol>
      <NumCol handleAction={onClickHandler("7")}>7</NumCol>
      <NumCol handleAction={onClickHandler("8")}>8</NumCol>
      <NumCol handleAction={onClickHandler("9")}>9</NumCol>
      {!hasEnter && <div />}
      <NumCol
        isLastNum={!hasDecimal && hasEnter}
        handleAction={onClickHandler("0")}
      >
        0
      </NumCol>
      {hasDecimal && <NumCol handleAction={onClickHandler(".")}>.</NumCol>}
      {hasEnter && (
        <NumCol isEnter handleAction={onClickHandler("Enter")}>
          <EnterButton>
            <div>Enter</div>
            <Checkmark icon="check" size="2x" />
          </EnterButton>
        </NumCol>
      )}
      {!hasEnter && (
        <NumCol handleAction={onClickHandler("back")}>
          <BackSpace icon="backspace" size="1x" />
        </NumCol>
      )}
    </NumPadContainer>
  );
};

const EnterButton = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${theme.fontSize.headings.h4};
  font-family: ${theme.fontFamily.light};
  text-transform: uppercase;
  > * {
    color: ${theme.color.white};
  }
`;

const NumPadContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: 1rem;

  &::before {
    content: "";
    width: 0;
    padding-bottom: 80%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  > *:first-child {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }
`;

const Checkmark = styled(FontAwesomeIcon)`
  color: white;
`;

const BackSpace = styled(FontAwesomeIcon)`
  color: ${theme.color.primary};
`;

export const MediumCenteredNumPad = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  > div {
    width: 80%;
  }
`;

export default NumPad;



// WEBPACK FOOTER //
// ./src/components/common/NumPad/index.tsx